import ChangesMonitor from './helpers/changes_monitor'
import SaveAndGoToOverviewBtnHandler from './helpers/save_and_go_to_overview_btn_handler'
import PostorderPermissionsVisibilityHandler from './helpers/postorder_permissions_visibility_handler'

export default function () {
  ChangesMonitor(true)
  SaveAndGoToOverviewBtnHandler()
  PostorderPermissionsVisibilityHandler()
}
